import { NavLink, Outlet } from "react-router-dom";

export default function AheadLayout() {
  const navItems = [
    { name: "Dashboard", to: "/Dashboard" },
    { name: "Category", to: "/ahead/events" },
    { name: "Venues", to: "/ahead/venues" },
    { name: "Events", to: "/ahead/sessions" },
    { name: "Organizers", to: "/ahead/organizers" },
    { name: "Referral", to: "/ahead/referral" },
    { name: "Host Request", to: "/ahead/hostrequest" },

    // { name: "Bookings", to: "/ahead/bookings" },
    // { name: "Holds", to: "/ahead/holds" },
    // { name: "Reports", to: "/ahead/reports" },
    // { name: "Check-in", to: "/admin/checkin" },
  ];

  const styles = {
    container: {
      display: "flex",
      minHeight: "100vh",
      background: "#F9FAFB", // gray-50
      fontFamily:
        "Inter, Roboto, system-ui, -apple-system, 'Segoe UI', 'Helvetica Neue', Arial",
    },
    aside: {
      width: 256, // w-64
      background: "#FFFFFF",
      boxShadow: "0 6px 18px rgba(15,23,42,0.06)",
      display: "flex",
      flexDirection: "column",
    },
    brand: {
      padding: "16px 24px",
      fontWeight: 700,
      fontSize: 18,
      borderBottom: "1px solid rgba(0,0,0,0.04)",
    },
    nav: {
      flex: 1,
      padding: "12px 16px",
      display: "flex",
      flexDirection: "column",
      gap: 8,
      overflowY: "auto",
    },
    linkBase: {
      display: "block",
      padding: "8px 12px",
      borderRadius: 8,
      fontSize: 14,
      fontWeight: 500,
      textDecoration: "none",
    },
    activeLink: {
      background: "#EEF2FF", // indigo-100
      color: "#3730A3", // indigo-700
    },
    inactiveLink: {
      color: "#374151", // gray-700
      transition: "background 120ms ease, color 120ms ease",
    },
    main: {
      flex: 1,
      overflowY: "auto",
      padding: 24,
      boxSizing: "border-box",
    },
  };

  return (
    <div style={styles.container}>
      <aside style={styles.aside}>
        <div style={styles.brand}>Ahead Admin</div>

        <nav style={styles.nav} aria-label="Admin navigation">
          {navItems.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              style={({ isActive }) => ({
                ...styles.linkBase,
                ...(isActive ? styles.activeLink : styles.inactiveLink),
              })}
            >
              {n.name}
            </NavLink>
          ))}
        </nav>
      </aside>

      <main style={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}
